// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import CustomModal from '../components/custom-modal';

import type { Reducers } from '../reducers';
import type { Project } from '../auth/with-project-context';
import type { OthersDelaysState } from './reducer';

import ActionTypes from './action-types';
import OthersDelays from './others-delays';
import withProjectContext from '../auth/with-project-context';

type Props = {
  project: Project,
  dispatch: Object => mixed,
  data: OthersDelaysState,
  week: string,
  projectId: string,
};

class OthersReasonContainer extends React.Component<Props> {
  componentDidMount() {
    this.props.dispatch({
      type: ActionTypes.GET_OTHERS_DELAYS,
      data: {
        projectId: this.props.projectId,
        week: this.props.week,
        project: this.props.project,
      },
    });
  }

  componentWillUnmount() {
    this.props.dispatch({ type: ActionTypes.CLEAR_OTHERS_DELAYS });
  }

  closeModal = () => {
    this.props.dispatch({
      type: 'hideModal',
    });
  }

  render(): React.Node {
    return (
      <CustomModal onClose={this.closeModal}>
        <OthersDelays data={this.props.data} />
      </CustomModal>
    );
  }
}

const connectedComponent: any = connect((state: Reducers): { data: Object } => ({ data: state.othersDelays }));

const Component: any = compose(connectedComponent, withProjectContext)(OthersReasonContainer);

export default Component;
